import ToolbarTable from "../custom/ToolbarTable";

const TablesToolbarGroup = () => {
  return (
    <>
      <ToolbarTable />
      <ToolbarTable align="left" />
      <ToolbarTable align="center" />
      <ToolbarTable align="right" />
    </>
  );
};

export default TablesToolbarGroup;
